import Home from '@/components/pages/Home'
import ContactUs from '@/components/pages/ContactUs'
import MortgageAdvice from '@/components/pages/MortgageAdvice'
import OurStory from '@/components/pages/OurStory'
import Protection from '@/components/pages/Protection'


/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * NOTE: When adding new routes, due to an issue with the vue-prerender
 * plugin, the routes need to be manually added to build/build.js. In
 * there there is a list of URLs to pre-render on deployment.
 *
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
*/
export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/mortgage-advice/',
    name: 'MortgageAdvice',
    component: MortgageAdvice,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact-us/',
    name: 'ContactUs',
    component: ContactUs,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/protection/',
    name: 'Protection',
    component: Protection,
    pathToRegexpOptions: { strict: true }
  },

  {
    path: '/our-story/',
    name: 'OurStory',
    component: OurStory,
    pathToRegexpOptions: { strict: true }
  }
]




// WEBPACK FOOTER //
// ./src/router/routes.js